import { render } from "./DialogConfirmReservationCancel.vue?vue&type=template&id=16f0bd2b"
import script from "./DialogConfirmReservationCancel.vue?vue&type=script&lang=js"
export * from "./DialogConfirmReservationCancel.vue?vue&type=script&lang=js"
script.render = render

export default script